// extracted by mini-css-extract-plugin
export default {"dividerContainer":"CategoryDivider_dividerContainer__pBPbK","categoryTitle":"CategoryDivider_categoryTitle__JZ6+O"};